/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Box, Stack, Placeholder, PlaceholderText } from 'sarsaparilla';

export function SearchResultCardPlaceholder() {
    return (
        <div data-component="SearchResultCard" className="placeholder">
            <div className="with-sidebar">
                <div className="sidebar">
                    <Placeholder />
                </div>
                <div className="not-sidebar">
                    <div className="details">
                        <Box padding={['sm', 'md']}>
                            <Stack space="sm">
                                <div>
                                    <PlaceholderText fontSize={18} lineHeight={21.6} />
                                    <PlaceholderText
                                        fontSize={12}
                                        lineHeight={20}
                                        width="60px"
                                    />
                                </div>
                            </Stack>
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
}
